import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface CoreCapability {
  id: string;
  icon: string;
  title: string;
  description: string;
}

@Component({
  selector: 'app-core-capabilities',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './core-capabilities.component.html',
  styleUrl: './core-capabilities.component.scss',
})
export class CoreCapabilitiesComponent {
  capabilities: CoreCapability[] = [
    { id: 'catalogue', icon: '/about-us/core/Database.svg', title: 'Unified Data Catalogue', description: 'Discover & assess agricultural datasets with rich metadata.' },
    { id: 'apis', icon: '/about-us/core/Code.svg', title: 'Secure Data Exchange APIs', description: 'Controlled access to real-time & historical data.' },
    { id: 'consent', icon: '/about-us/core/UserCircleCheck.svg', title: 'Consent-driven Data Access', description: 'Purposeful, auditable data sharing with privacy protection.' },
    { id: 'control', icon: '/about-us/core/Key.svg', title: 'Data Provider Control', description: 'Providers retain full sovereignty over data access & usage.' },
    { id: 'sandbox', icon: '/about-us/core/CodesandboxLogo.svg', title: 'AI Sandbox', description: 'Scalable compute for building and testing agri-AI solutions.' },
    { id: 'community', icon: '/about-us/core/UsersThree.svg', title: 'Community Layer', description: 'Forums, hackathons, & shared learning to drive innovation.' },
  ];
}
